import { ActivityWalletCreateProcessStatusType } from '@golden/gdk-admin'

const activityWalletQueuesStatusColor: { [key in ActivityWalletCreateProcessStatusType]: string } = {
  [ActivityWalletCreateProcessStatusType.PENDING]: '#808080',
  [ActivityWalletCreateProcessStatusType.PROCESSING]: '#72d476',
  [ActivityWalletCreateProcessStatusType.FAILED]: '#ff5f5f'
}

export default activityWalletQueuesStatusColor
